// IMPORT REACT
import React from 'react';

// IMPORT STYLES
import { SC_Accordian } from './styles';


const YAAccordian = (props) => {
  
  return (
  	<SC_Accordian>
  		{props.children}
  	</SC_Accordian>
  )
    
}
export default YAAccordian;